const variableSalaryModal = {
  namespaced: true,

  state: () => ({
    hoveredVariable: undefined,
  }),

  actions: {
    async setHoveredVariable(context, hoveredVariable) {
      context.commit("setHoveredVariable", hoveredVariable);
    },
  },

  mutations: {
    setHoveredVariable(state, hoveredVariable) {
      state.hoveredVariable = hoveredVariable;
    },
  },

  getters: {
    hoveredVariable: (state) => state.hoveredVariable,
  },
};

export default variableSalaryModal;
